export default __webpack_public_path__ + "static/media/eu-par.d8978e40.png";